import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import map from './map'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
let lang = 'en'
if (typeof navigator !== 'undefined') {
  lang = navigator.language || navigator.userLanguage
  lang = lang.substr(0, 2)
}
const langStore = {
  namespaced: false,
  state: {
    lang: lang //window.localStorage.getItem('lang')
  },
  getters: {
    getLang (state) {
      return state.lang
    }
  },
  mutations: {
    setLang (state, lang) {
      state.lang = lang
    }
  },
  plugins: [vuexLocal.plugin]
}

const modules = {
  lang: langStore,
  map: map,
}

const store = new Vuex.Store({
  modules: modules,
  // plugins: [vuexLocal.plugin]
  // plugins:[vuexSession.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js